// GENERADO — no editar a mano. Origen: backend/src/oficina/compartido/.
// Regenerar: node scripts/gen-oficina-compartido.mjs

// Colores de sala (04-11, web/qa/auditoria-apple/visual.md §2.D.22). El color de una sala solo vive en el punto de su
// cabecera, y no puede ser el oro de Venuz (el oro significa «actúa») ni un color de estado (verde trabajando, naranja
// aviso, rojo problema, violeta «no puede seguir», cian Santi). Colores de sistema de Apple en oscuro que quedan libres.
// Código PURO y sin imports: lo usan el servidor (validar y servir) y la web (elegir en «Ajustes de la sala»).

export const COLORES_SALA = ['#FF375F', '#0A84FF', '#5E5CE6', '#66D4CF', '#AC8E68', '#98989D'] as const;
export type ColorSala = (typeof COLORES_SALA)[number];

/** Los de antes del 04-11 (el oro por defecto y la paleta vieja del diálogo), al más parecido de la paleta nueva. */
const ANTES: Record<string, ColorSala> = {
  '#C9A227': '#FF375F', // oro por defecto (migración 058)
  '#F0B90B': '#FF375F', // oro
  '#E9C24A': '#FF375F', // oro de las maquetas
  '#EF5B5B': '#FF375F', // rojo
  '#4F9CF5': '#0A84FF', // azul
  '#A77BF3': '#5E5CE6', // violeta
  '#4FC37A': '#66D4CF', // verde
  '#FF8A3D': '#AC8E68', // naranja
  '#9AABBC': '#98989D', // gris
};

export const esColorSala = (color: string): color is ColorSala => (COLORES_SALA as readonly string[]).includes(color.toUpperCase());

/** El color con el que se pinta una sala: el suyo si es de la paleta; si no (guardado antes del 04-11), el equivalente. */
export function colorDeSala(color: string): ColorSala {
  const c = color.toUpperCase();
  if (esColorSala(c)) return c;
  if (ANTES[c]) return ANTES[c];
  // Cualquier otro: uno fijo de la paleta según el valor (el mismo cada vez).
  let h = 0;
  for (const ch of c) h = (h * 31 + ch.charCodeAt(0)) >>> 0;
  return COLORES_SALA[h % COLORES_SALA.length]!;
}
